export default __webpack_public_path__ + "static/media/speed-preset.f1cedac6.svg";